export default __webpack_public_path__ + "static/kb_3_3-48f067a44a168bfd3cff73bccc32cd8a.jpeg";